import React, { useState, useContext, useEffect } from 'react'
import { motion } from 'framer-motion'
/*COMPONENTS */
import Header from '../../components/Header'
import SidebarEl from '../../components/SidebarEl'
import styled from 'styled-components'
import ModalRequestCart from '../../components/ModalRequestCart'
import { ToastContainer, toast } from 'react-toastify';
import Filter from '../../components/Filter'
import TableListFinancial from '../../components/TableListFinancial'
import { PieChart } from '@mui/x-charts/PieChart';
import { DashboardContext } from '../../context/dashboard'
import DatePicker, { registerLocale } from "react-datepicker";
import { FaFilter } from 'react-icons/fa';

import calendarIcon from '../../images/png/calendar.png'
import Dropdown from 'react-bootstrap/Dropdown';

const CardWrapper = styled.section`
    background-color: white;
    height: 100vh;
    display: flex;
    overflow-x: hidden;
   
  
    .colum_primary{ 
        flex:0.1;
    }


    .colum_secondary{
        display: flex;
        flex:1;
        padding: 1.7rem;
        flex-direction: column;
        width: 100%;
        background-color: #ffbf00;
        background-image: url("../images/png/banner.jpeg");
    }

    @media screen and (max-width:720px){
    .colum_primary{ 
        flex:0;

    }

        .colum_secondary{
        display: flex;
        flex:1;
        flex-direction: column;
        width: 100%;
    }
    }

`
const CleanMobile = styled.div`

@media screen and (max-width:720px){
        height:120px
    }

`
const RowDashboard = styled.div`

    display: flex;
    justify-content:space-between; 
    align-items: center;

    @media screen and (max-width:720px){
        width: 100%;
        flex-direction: column;
    }

`
const FixWidthSidebar = styled.div`
    display: block;
    width: 130px;
    @media screen and (min-width:1800px){
        display: block;
        width: 60px;
    }

    @media screen and (max-width:820px){
        display: none;
    }


`
const Button = styled.button`
    width: 100%;
    height: 34px;
    border: none;
    font-family: "Poppins";
    font-weight: 500;
    color: white;
    font-size: 0.9rem;
    background-color: rgba(0,0,0,.774);
    border-radius: 50px;

`
const ContainerDashboard = styled.div`
    margin-top: 5rem;
    z-index: 99999999;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .textDate{
        font-family: "Poppins";
        font-weight: bold;
        font-size: 1.2rem;
    }

    .textTop{
        color:white;
        font-family: "Poppins";
        font-weight: bold;
        font-size: 2.1rem;
        text-align:center;
    }
    

`
const Dashboard = styled.div`
    margin-top: 0.1rem;
    z-index: 99999999;
    border-radius: 5px;
    background-color: #ffffff;
    box-shadow: 0 0 5px #a5a5a5b5;
    width: 690px;
    height: 150px;
    display: flex;
    justify-content: center;
    align-items: center;

    .textPrimary{
        color:#f4b429;
        font-weight: 600;
        font-family: "Poppins";
        position: relative;
        top: 12px;
        margin-right: 1.0rem;
        font-size: 3.5rem;
    }

    .textSecondary{
        color:#f4b429;
        font-weight: 600;

        margin-top: 0.9rem;
        font-family: "Poppins";
        font-size: 5.5rem;

    }

    @media screen and (max-width:820px){
        width: 90%;

    }


`
const CalendarIcon = styled.img`
    width: 25px;
    height: 25px;
    margin-bottom: 1.2rem;

`
const ContainerCalendar = styled.div`

    margin-bottom: 0.5rem;

`

const Financial = () => {

    const { total, getTotal } = useContext(DashboardContext)
    const [selectedDate, setSelectedDate] = useState(null); // Armazena a data selecionada
    const [totalFinancial,setTotalFinancial] = useState(0)
    const [time, setTime] = useState()
    const date = new Date()

    const [seconds, setSeconds] = useState(0);

    useEffect(() => {
        const updateTime = () => {
            const date = new Date();
            const hours = date.getHours();
            const minutes = date.getMinutes();
            const seconds = date.getSeconds();
            setTime(`${hours}:${minutes < 10 ? `0${minutes}` : minutes}`);
            setSeconds(seconds);
        };

        // Atualiza o relógio imediatamente
        updateTime();

        // Atualiza a cada 1 segundo
        const interval = setInterval(updateTime, 1000);

        // Limpa o intervalo ao desmontar o componente
        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        let index = 0;
        let currentTotalFinancial = 0;
    
        while (currentTotalFinancial < total) {
            
            currentTotalFinancial = index;
            index++;
        }

        
        setTotalFinancial(currentTotalFinancial);
    
        getTotal(selectedDate); // Supondo que esta função faça algo com selectedDate
    
    }, [total, selectedDate]);
    



    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
        >
            <ToastContainer />
            <CardWrapper style={{ overflowX: "hidden" }}
            >
                <div className='colum_primary'>
                    <SidebarEl />
                </div>

                <FixWidthSidebar />

                <div className='colum_secondary'>

                    <Header name="Minhas Vendas" color="white" financial={true} zIndex={999999} />
                    <ContainerDashboard>        
                        <p className='textTop'>Vendas Hoje</p>
                        <p className='textDate'>

                            {date.toLocaleDateString('pt-br')} - {time}:{seconds}
                        </p>
                        <ContainerCalendar>
                        <Dropdown>
                            <Dropdown.Toggle id="dropdown-basic" style={{background:"black"}}>
                                Filtrar  <FaFilter />
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                                <DatePicker
                                    selected={selectedDate}
                                    onChange={(date) => { setSelectedDate(date); }}
                                    inline // Exibe o calendário aberto
                                    locale={'pt-BR'}

                                />
                                <Button >Filtrar</Button>
                            </Dropdown.Menu>


                        </Dropdown>

                        </ContainerCalendar>
                        <Dashboard>
                            <p className='textPrimary'>R$</p>
                            <p className='textSecondary'>{Number(totalFinancial).toLocaleString("pt-br",{minimumFractionDigits:2})}</p>

                        </Dashboard>


                    </ContainerDashboard>

                </div>
            </CardWrapper>
        </motion.div>

    )
}

export default Financial